import { loadUserAuthority, getLoginUser, getServerMap, getUnique } from "@/api/common";

const menu = {
  state: {
    acountList: [], // 账号列表信息
    serviceList: [], // 服务列表
    currentUser: {}, // 当前账号信息
    consolemoduleList: [], // 门户权限
    registerMicroApps: [], // 门户内置所有子应用appCode
    consoleMenulist: [], // 门户菜单
    microApp: null, // 子应用实例
    subappPermission: [], // 子应用权限
    subappMenuList: [], // 子应用菜单
    subappCode: "", // 子应用appcode
    subviewBreadcrumb: [], // 子应用路由matched
    hiddenBreadcrumb: true, // 子应用路由面包屑是否展示，默认展示
    subappClassName: "", // 设置子应用打包根的class类名
    personalInfo: {
      // 个人中心 信息
      userUuid: "",
      authResult: 0, // 实名结果，0：未实名，1：已实名
      displayName: "", // 姓名
      username: "", // 账号
      avatar: "", // 头像
      phone: "",
      email: ""
    },
    mountappLoaded: false // 子应用是否加载完成
  },
  mutations: {
    // 添加账号列表相关信息
    SET_ACOUNTINFO: (state, data) => {
      const { acountList, user, registerMicroApps } = data || {};

      state.acountList = acountList || [];
      state.currentUser = user || {};
      state.consolemoduleList = user.moduleList || [];
      state.registerMicroApps = registerMicroApps || [];
    },

    // 个人中心信息
    SET_PERSONALINFO: (state, data) => {
      state.personalInfo = data;
    },

    // 添加门户菜单
    ADD_CONSOLE_MENULIST: (state, data) => {
      state.consoleMenulist = data || [];
    },

    // 添加子应用（服务）信息如菜单、appCode等
    ADD_SUBAPP_INFO: (state, data) => {
      const { permission, menuList, appCode } = data;

      state.subappPermission = permission || [];
      state.subappMenuList = menuList || [];
      state.subappCode = appCode || "";
    },

    // 添加子应用qiankun实例
    ADD_MICROAPP: (state, data) => {
      state.microApp = data;
    },

    // 清空子应用qiankun实例
    CLEAR_MICROAPP: (state) => {
      state.microApp = null;
    },

    // 清空子应用数据（菜单、appcode等）
    CLEAR_SUBAPPINFO: (state) => {
      state.subappPermission = [];
      state.subappMenuList = [];
      state.subappCode = "";
    },

    // 清理用户个人信息
    CLEAR_LOGINUSER: (state) => {
      state.personalInfo = {
        userUuid: "",
        authResult: 0, // 实名结果，0：未实名，1：已实名
        displayName: "",
        username: "", // 账号
        avatar: "", // 头像
        phone: "",
        email: ""
      };
    },

    // 设置子应用matched
    SET_SUBVIEWBREADCRUMB: (state, data) => {
      state.subviewBreadcrumb = data || [];
    },
    // 设置子应用面包屑是否展示
    SET_HIDDENSUBVIEWBREADCRUMB: (state, data) => {
      state.hiddenBreadcrumb = data || false;
    },

    // 设置子应用打包根的class类名
    SET_SUBAPP_CLASSNAME: (state, data) => {
      state.subappClassName = data;
    },

    // 设置子应用加载完成状态
    SET_MOUNTAPP_LOADED: (state, data) => {
      state.mountappLoaded = data || false;
    },

    // 设置服务列表
    SET_SERVICELIST: (state, data) => {
      state.serviceList = data;
    },

    // 清空账号列表
    CLEAR_ACCOUNTLIST: (state) => {
      state.acountList = [];
    }
  },
  actions: {
    // 获取账号列表
    getUserAcountList({ commit }, { uuid, type, appCode } = {}) {
      return new Promise((resolve, reject) => {
        loadUserAuthority({ uuid, type, appCode })
          .then((res) => {
            const acountList = res.data.companyList || []; // 账号列表
            const registerMicroApps = res.data.registerMicroApps || []; // 微应用列表
            const user = acountList.find((item) => item.isCurrent); // 当前登录用户

            if (appCode == "operation") {
              commit("SET_ACOUNTINFO", { acountList, user, registerMicroApps });
            }
            resolve({ user, acountList, registerMicroApps });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    // 获取当前登陆的用户信息
    UpdateUserInfo({ commit }, data) {
      return new Promise((resolve, reject) => {
        let params = {};
        const { reload } = data || {};

        if (reload) {
          params.reload = reload;
        }
        getLoginUser(params).then((res) => {
          if (res && res.data) {
            commit("SET_PERSONALINFO", res.data);
          }
        });
        //记录是否开启企业唯一
        getUnique().then((res) => {
          if (res && res.data) {
            sessionStorage.setItem("abbreviation", res.data);
          } else {
            sessionStorage.setItem("abbreviation", res.data);
          }
        });
      });
    },

    // 清理当前登录的用户信息
    clearLoginUser({ commit }) {
      commit("CLEAR_LOGINUSER");
    },

    // 添加门户菜单
    AddConsoleMenu({ commit }, data) {
      commit("ADD_CONSOLE_MENULIST", data);
    },

    // 添加门户内置子应用信息（实名等）
    AddBuiltSubappInfo({ commit }, data) {
      return new Promise((resolve) => {
        commit("ADD_BUILTSUBAPP_INFO", data);
        resolve();
      });
    },

    // 添加子应用（服务）信息如菜单、appCode等
    AddSubappInfo({ commit }, data) {
      return new Promise((resolve) => {
        commit("ADD_SUBAPP_INFO", data);
        resolve();
      });
    },

    // 添加子应用qiankun实例
    AddMicroApp({ commit }, data) {
      return new Promise((resolve) => {
        commit("ADD_MICROAPP", data);
        resolve();
      });
    },

    // 清空子应用qiankun实例
    ClearMicroApp({ commit }) {
      return new Promise((resolve) => {
        commit("CLEAR_MICROAPP");
        resolve();
      });
    },

    // 清空子应用数据（菜单、appcode等）
    clearSubappInformation({ commit }) {
      return new Promise((resolve) => {
        commit("CLEAR_SUBAPPINFO");
        resolve();
      });
    },

    // 设置子应用matched
    setSubviewBreadcrumb({ commit }, data) {
      commit("SET_SUBVIEWBREADCRUMB", data);
    },

    // 设置子应用面包屑是否展示
    setHiddenSubviewBreadcrumb({ commit }, data) {
      commit("SET_HIDDENSUBVIEWBREADCRUMB", data);
    },

    // 设置子应用打包根的class类名
    setSubappClassName({ commit }, data) {
      commit("SET_SUBAPP_CLASSNAME", data);
    },

    // 设置子应用加载完成状态
    setMountAppLoaded({ commit }, data) {
      commit("SET_MOUNTAPP_LOADED", data);
    },

    // 获取服务列表
    GetServiceList({ commit }) {
      return new Promise((resolve, reject) => {
        getServerMap()
          .then((res) => {
            const result = res.data || [];

            commit("SET_SERVICELIST", result);
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  }
};

export default menu;



// WEBPACK FOOTER //
// ./src/store/modules/menu.js